module.exports = __webpack_public_path__ + "assets/img/commdiygroup.1d94944b.svg";